import { API_REQUEST } from ".";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { pageRoutes } from "../../routes/pageRoutes";
import { pipSaveTeamDirectory } from "../../utils/pip";

import {
  profileAPI,
  botTypesAPI,
  courseListAPI,
  memberLoginAPI,
  getMyAddressAPI,
  deleteAddressAPI,
  profileUpdateAPI,
  changePasswordAPI,
  forgotPasswordAPI,
  memberRegisterAPI,
  acceptInvitaionAPI,
  deleteInvitaionAPI,
  authLoginCallbackAPI,
  updateMemberDetailAPI,
  fetchClassesInvitationsListAPI,
  getWeightClassesCategoriesAPI,
  createBotAPI,
  updateBotAPI,
  deleteBotAPI,
  delteTeamAPI,
  memberDetailAPI,
} from "../../routes/apiEndPoints";

// auth-register
export const authRegister = createAsyncThunk("auth-register", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: memberRegisterAPI,
      method: "POST",
      data: payload,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

// auth-login
export const authLogin = createAsyncThunk("auth-login", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: memberLoginAPI,
      method: "POST",
      data: payload,
      isErrorToast: true,
    });
    pipSaveTeamDirectory(response?.data);

    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

// auth-forgot-password
export const authForgotPassword = createAsyncThunk(
  "auth-forgot-password",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: forgotPasswordAPI,
        method: "POST",
        data: payload,
        isErrorToast: true,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// fetch-profile
export const fetchProfile = createAsyncThunk("fetch-profile", async () => {
  try {
    const response = await API_REQUEST({
      url: profileAPI,
      method: "GET",
    });
    return response;
  } catch (error) {}
});

// auth-change-password
export const changePassword = createAsyncThunk(
  "auth-change-password",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: changePasswordAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// update-profile
export const updateProfile = createAsyncThunk(
  "update-profile",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: profileUpdateAPI,
        method: "POST",
        data: payload,
        isErrorToast: true,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// fetch-addresses
export const fetchAddresses = createAsyncThunk("fetch-addresses", async () => {
  try {
    const response = await API_REQUEST({
      url: getMyAddressAPI,
      method: "GET",
    });
    return response;
  } catch (error) {}
});

// delete-address
export const deleteAddress = createAsyncThunk(
  "delete-address",
  async (props) => {
    try {
      const { payload, callback } = props;
      const response = await API_REQUEST({
        url: deleteAddressAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {}
  }
);

// fetch-invitaitons-list
export const fetchClassesInvitations = createAsyncThunk(
  "fetch-invitaitons-list",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: fetchClassesInvitationsListAPI,
        method: "POST",
        data: payload,
        isErrorToast: false,
        isSuccessToast: false,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// reject-invitation
export const rejectInvitaion = createAsyncThunk(
  "reject-invitation",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: deleteInvitaionAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// accept-invitation
export const acceptInvitaion = createAsyncThunk(
  "accept-invitation",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: acceptInvitaionAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// fetch-course-list
export const fetchCourseList = createAsyncThunk(
  "fetch-course-list",
  async () => {
    try {
      const response = await API_REQUEST({
        url: courseListAPI,
        method: "GET",
        isErrorToast: false,
      });
      return response;
    } catch (error) {}
  }
);

// auth-login-callback
export const authLoginCallback = createAsyncThunk(
  "auth-login-callback",
  async (props) => {
    const { payload, callback, role } = props;
    try {
      const response = await API_REQUEST({
        url: `${authLoginCallbackAPI}${role}` + `${payload}`,
        method: "GET",
      });
      callback(response);
      return response;
    } catch (error) {
      setTimeout(() => {
        window.location.href = pageRoutes?.studentPanelLoginRedirection;
      }, 1000);
    }
  }
);

// auth-update-member-detail
export const authUpdateMemberDetails = createAsyncThunk(
  "auth-update-member-detail",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: updateMemberDetailAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {}
  }
);

// fetch-bot-types
export const fetchBotTypes = createAsyncThunk("fetch-bot-types", async () => {
  try {
    const response = await API_REQUEST({
      url: botTypesAPI,
      method: "GET",
      isErrorToast: false,
    });
    return response;
  } catch (error) {}
});

// fetch-wieght-class-categories
export const fetchWeightClassCategories = createAsyncThunk(
  "fetch-wieght-class-categories",
  async () => {
    try {
      const response = await API_REQUEST({
        url: getWeightClassesCategoriesAPI,
        method: "GET",
        isErrorToast: false,
      });
      return response;
    } catch (error) {}
  }
);

// create-bot
export const CreateBot = createAsyncThunk(
  "create-bot",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: createBotAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);
// update-bot
export const updateBot = createAsyncThunk(
  "update-bot",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: updateBotAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);
// delete-bot
export const DeleteBot = createAsyncThunk(
  "delete-bot",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: deleteBotAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);
// delete-team
export const DeleteTeam = createAsyncThunk(
  "delete-team",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: delteTeamAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// fetch-team-member
export const fetchTeamMember = createAsyncThunk("fetch-team-member", async (props) => {
  try {
    const {payload} = props
    const response = await API_REQUEST({
      url: memberDetailAPI,
      method: "POST",
      data:payload,
      isErrorToast: false,
      isSuccessToast: false,
    });
    return response;
  } catch (error) {}
});